import { RawReceipt } from '../storefront.types'

export const hasReceipt = (receipt: RawReceipt): boolean =>
  receipt && receipt !== null
